import { useEffect, useState } from 'react'

export const useWebView = () => {
  const [isWebView, setIsWebView] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('isWebView=true')) {
      setIsWebView(true)
      sessionStorage.setItem('isWebView', 'true')
    } else {
      const isWebViewFromStorage = sessionStorage.getItem('isWebView')

      if (isWebViewFromStorage) {
        setIsWebView(isWebViewFromStorage === 'true')
      }
    }
  }, [])

  return { isWebView, setIsWebView }
}
